import {
    animateElementOnce,
    findRenderedTranslations,
    hoveredTranslationClassName
} from './renderedTranslations';

export const updatedTextClassName = 'translation-editor-updated-text';

export const selectedKeyClassName = 'translation-editor-selected-key';

const updatedTextAnimationName = 'translation-editor-updated-text-pulse';

const selectedKeyAnimationName = 'translation-editor-selected-key-pulse';

export const editorHighlightStyles = {
    [`@keyframes ${updatedTextAnimationName}`]: {
        '0%, 100%': { backgroundColor: 'transparent' },
        '20%, 60%': { backgroundColor: 'rgba(255, 213, 79, 0.35)' },
        '40%, 80%': { backgroundColor: 'transparent' }
    },
    [`.${updatedTextClassName}`]: {
        animation: `${updatedTextAnimationName} 2.4s ease-in-out 1`,
        borderRadius: '2px'
    },
    [`@keyframes ${selectedKeyAnimationName}`]: {
        '0%, 100%': { backgroundColor: 'transparent', boxShadow: '0 0 0 0 rgba(33, 150, 243, 0)' },
        '50%': {
            backgroundColor: 'rgba(33, 150, 243, 0.25)',
            boxShadow: '0 0 0 4px rgba(33, 150, 243, 0.35)'
        }
    },
    [`.${selectedKeyClassName}`]: {
        animation: `${selectedKeyAnimationName} 0.7s ease-in-out 2`,
        borderRadius: '2px'
    },
    [`.${hoveredTranslationClassName}`]: {
        backgroundColor: 'rgba(33, 150, 243, 0.15)',
        outline: '1px dashed rgba(33, 150, 243, 0.7)',
        outlineOffset: '1px',
        borderRadius: '2px'
    }
};

function afterRender(action: () => void) {
    window.requestAnimationFrame(() => {
        window.requestAnimationFrame(action);
    });
}

export function highlightTranslatedText(text: string | null) {
    if (!text) {
        return;
    }

    findRenderedTranslations((rendered) => rendered.text === text).forEach((rendered) =>
        animateElementOnce(rendered.element, updatedTextClassName)
    );
}

export function highlightTranslatedTextAfterRender(text: string | null) {
    afterRender(() => highlightTranslatedText(text));
}

export function pulseTranslationKey(key: string) {
    findRenderedTranslations((rendered) => rendered.key === key).forEach((rendered) =>
        animateElementOnce(rendered.element, selectedKeyClassName)
    );
}

export function pulseTranslationKeyAfterRender(key: string) {
    afterRender(() => pulseTranslationKey(key));
}
